import { useState, useEffect } from "react";

/**
 * useIsPortrait — true when the viewport is taller than it is wide.
 *
 * The play-through stage uses it with useIsCompact: a phone held upright
 * shows every picture whole (contain, on a blurred backdrop) instead of
 * cropping a landscape photo to a sliver (David, Oct 15); turned sideways,
 * the picture covers the screen as before. Defaults to portrait where
 * matchMedia is unavailable (tests, SSR) — phone-first, like useIsCompact.
 */
const PORTRAIT_QUERY = "(orientation: portrait)";

export function useIsPortrait() {
  const [portrait, setPortrait] = useState(() => {
    if (typeof window === "undefined" || !window.matchMedia) return true;
    return window.matchMedia(PORTRAIT_QUERY).matches;
  });
  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia(PORTRAIT_QUERY);
    const onChange = e => setPortrait(e.matches);
    if (mq.addEventListener) mq.addEventListener("change", onChange);
    else mq.addListener(onChange);
    setPortrait(mq.matches);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", onChange);
      else mq.removeListener(onChange);
    };
  }, []);
  return portrait;
}
